import { Box, Heading, Paragraph, Tag } from '@zillow/constellation-10';
import type { Document } from '../../../../../models/rental-application';
import { DATE_COVERAGE_NOT_VERIFIED, NO_FILES_ADDED } from '../../../../../constants/incomeDocuments';
import { DocumentCard } from './DocumentCard';

type Props = {
  heading: string;
  tag?: string;
  requirement?: string;
  isRequested?: boolean;
  documents: Array<Document>;
};

export function DocumentContainer({ heading, tag, requirement, isRequested, documents }: Props) {
  return (
    <Box css={{ display: 'flex', flexDirection: 'column', gap: 'tighter' }}>
      <Box css={{ display: 'flex', alignItems: 'center', gap: 'tighter', flexWrap: 'wrap' }}>
        <Heading level={4} textStyle="body-lg-bold">
          {heading}
        </Heading>
        {tag && (
          <Tag size="sm" css={{ maxWidth: '100%', overflowWrap: 'anywhere' }}>
            {tag}
          </Tag>
        )}
      </Box>
      {requirement && (
        <Paragraph textStyle="body-sm-bold" color="text.subtle">
          {requirement}
        </Paragraph>
      )}
      {isRequested && (
        <Paragraph textStyle="body-sm" color="text.subtle">
          {DATE_COVERAGE_NOT_VERIFIED}
        </Paragraph>
      )}
      {documents.length > 0 ? (
        <Box css={{ display: 'grid', gridTemplateColumns: 'repeat(12, 1fr)', gap: 'tighter' }}>
          {documents.map((document, index) => (
            <Box
              key={document.id ?? `pending-${index}`}
              css={{ gridColumnEnd: { base: 'span 12', md: 'span 6', lg: 'span 4' } }}
            >
              <DocumentCard document={document} canDelete={false} />
            </Box>
          ))}
        </Box>
      ) : (
        <Paragraph textStyle="body-sm" color="text.subtle">
          {NO_FILES_ADDED}
        </Paragraph>
      )}
    </Box>
  );
}
